import type { MaybeRef } from "vue"

interface UsePaginationOptions {
  count: MaybeRef<number>
  limit: MaybeRef<number>
}

export const useDRFPagination = ({
  count,
  limit = 10,
}: UsePaginationOptions) => {
  const defaultPagination = computed(() => ({
    limit: unref(limit),
    page: 1,
  }))
  const pagination = ref<Pagination>({
    ...defaultPagination.value,
  })

  const resetPagination = () => {
    pagination.value = { ...defaultPagination.value }
  }

  const page = computed({
    get: () => pagination.value.page,
    set: (value) => {
      pagination.value.page = value
    },
  })

  const pageCount = computed(() =>
    Math.ceil(unref(count) / pagination.value.limit)
  )

  return {
    page,
    pageCount: readonly(pageCount),
    pagination: readonly(pagination),
    resetPagination,
  }
}
